import { Wrapper } from "./styled";

const ErrorMessage = () => (
    <Wrapper>
        ❌ Coś poszło nie tak. Sprawdź połączenie internetowe i spróbuj
        ponownie.
    </Wrapper>
);

export default ErrorMessage;
